/* YOXYOX – Categories Panel + Desktop All-Categories Sidebar
   v2.0 — sidebar accordion, mobile bottom-sheet, hero chips
*/
(() => {
  /* ── Desktop / Mobile All-Categories Sidebar ─────────────────────────── */
  const sidebar  = document.getElementById('yx-desktop-cats');
  const overlay  = document.getElementById('yx-desktop-cats-overlay');
  const allBtns  = Array.from(document.querySelectorAll('#yx-all-cats-btn, #yx-all-cats-btn-mobile'));
  const closeBtn = sidebar && sidebar.querySelector('.yx-desktop-cats__close');

  if (!sidebar || allBtns.length === 0) return;

  const openSidebar = () => {
    sidebar.hidden  = false;
    overlay && (overlay.hidden = false);
    requestAnimationFrame(() => {
      sidebar.classList.add('is-open');
    });
    allBtns.forEach(b => b.setAttribute('aria-expanded','true'));
    document.body.style.overflow = 'hidden';
  };

  const closeSidebar = () => {
    sidebar.classList.remove('is-open');
    allBtns.forEach(b => b.setAttribute('aria-expanded','false'));
    document.body.style.overflow = '';
    const onEnd = () => {
      sidebar.hidden  = true;
      overlay && (overlay.hidden = true);
      sidebar.removeEventListener('transitionend', onEnd);
    };
    sidebar.addEventListener('transitionend', onEnd);
  };

  allBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const isOpen = sidebar.classList.contains('is-open') || allBtns.some(b => b.getAttribute('aria-expanded') === 'true');
      isOpen ? closeSidebar() : openSidebar();
    });
  });

  closeBtn  && closeBtn.addEventListener('click', closeSidebar);
  overlay   && overlay.addEventListener('click', closeSidebar);
  document.addEventListener('keydown', e => { if (e.key==='Escape') closeSidebar(); });

  /* Close when a category link is clicked */
  sidebar.addEventListener('click', e => {
    if (e.target.closest('a')) closeSidebar();
  });

  /* ── Accordion sub-menus inside sidebar ─────────────────────────────── */
  sidebar.querySelectorAll('.yx-dcat-item--has-sub .yx-dcat-parent').forEach(parent => {
    parent.addEventListener('click', () => {
      const item = parent.closest('.yx-dcat-item');
      const isOpen = item.classList.contains('is-open');
      /* close all others */
      sidebar.querySelectorAll('.yx-dcat-item.is-open').forEach(el => el.classList.remove('is-open'));
      if (!isOpen) item.classList.add('is-open');
    });
  });

  /* ── Quick-chips drag-scroll (mouse) ─────────────────────────────────── */
  document.querySelectorAll('.yx-quickchips').forEach(el => {
    let isDown = false, startX, scrollLeft;
    el.addEventListener('mousedown', e => {
      isDown = true; el.classList.add('yx-dragging');
      startX = e.pageX - el.offsetLeft; scrollLeft = el.scrollLeft;
    });
    const end = () => {
      if (!isDown) return; isDown = false;
      el.classList.remove('yx-dragging');
      setTimeout(() => el.classList.remove('yx-no-click'), 50);
    };
    el.addEventListener('mouseleave', end);
    el.addEventListener('mouseup', end);
    el.addEventListener('mousemove', e => {
      if (!isDown) return; e.preventDefault();
      const x = e.pageX - el.offsetLeft;
      const walk = (x - startX) * 1.4;
      if (Math.abs(walk) > 5) el.classList.add('yx-no-click');
      el.scrollLeft = scrollLeft - walk;
    });
  });
})();
